import React, {useEffect} from "react";
import {
    isAndroid,
    isIOS
} from "react-device-detect";

import * as Firebase from "../firebase";

export const AppStore = () => {

    useEffect(() => {
        Firebase.logEventTest();

        if (isAndroid) {
            window.location.href =
                "https://play.google.com/store/apps/details?id=com.lazilyinspired.lovetennis";
        }else if(isIOS) {
            window.location.href =
                "https://apps.apple.com/us/app/tennisphere/id1567234371";
        } else{
            window.location.href =
                "https://tennisphere.com";
        }
    }, []);


    return (
        <>
        </>
    ) ;
};

